<template>
    <div class="w-full sm:6/12 md:4/12 lg:3/12 mt-2 sm:mt-6 px-5 sm:pl-4 sm:pr-4">
        <div @click.prevent="openProduct" class="card card-product card-profile cursor-pointer text-center rounded shadow-none transition duration-200 border border-gray-300 hover:border-gray-500">
            <img v-if="product.image_url" :data-src="product.image_url" :alt="product.name" class="lazyload card-img-top object-contain" />
            <div v-if="!product.image_url" class="h-32"></div>

            <div class="card-body pb-2 cursor-pointer">
                <div>
                    <h5 class="sm:h-16 overflow-hidden text-truncate2 font-semibold mt-4 mb-0 text-base">
                        <a href="javascript:void(0)">{{ product.name }}</a>
                    </h5>

                    <div class="w-full">
                        <button type="button" class="btn btn-block btn-primary border-2 rounded-full font-semibold">
                            <i class="fad fa-shopping-cart fa-lg mr-1"></i>
                            View Product
                        </button>

                        <!-- <follow-product-button :product="product" btn-class="btn-block" /> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['product'],

    data: () => ({}),

    created() {
        Bus.$on("productChecked", product => {
            if (this.product.id === product.id) {
                // this.product = product;
                this.product.price = product.price;
                this.product.stocked = product.stocked;
                this.product.checked_at = product.checked_at;
                this.product.stocked_at = product.stocked_at;
                this.product.updated_at = product.updated_at;
            }
        });
    },

    mounted() {},

    computed: {},

    methods: {
        openProduct($event) {
            $event.preventDefault();
            $event.stopPropagation();

            // const url = this.product.click_url;
            const url = this.product.go_url + '?f=1';

            window.open(url, '_blank');

            window.trackProductClick(this.product, url, 'product');
        }
    }
}
</script>

<style lang="scss">
.marker-warning.marker-ribbon {
    color: #333;
    background-color: #f7cb2e;
}

.card-profile {
    .card-img-top {
        object-fit: contain !important;
    }
}

.card-product {
    .card-body {
        border-bottom-width: 0;
        border-left-width: 0;
        border-right-width: 0;
    }
}
</style>
